module.exports = __webpack_public_path__ + "static/media/NanumSquareB.81807f54.eot";